module.exports = __webpack_public_path__ + "a5367711a279246e83fb0612f56b088a.svg";